//#region src/utils/distance/haversine-distance.ts
const RADIUS_OF_EARTH_IN_KM = 6371;
const KM_TO_MILES = 1.60934;
const DEGREES_TO_RADIANS = Math.PI / 180;
const toRadian = (angle) => DEGREES_TO_RADIANS * angle;
const distance = (a, b) => DEGREES_TO_RADIANS * (a - b);
/**
* Calculates the haversine distance between geographical points A and B.
* @param {number[]} coordA [lat, lng] point A
* @param {number[]} coordB [lat, lng] point B
*/
const haversineDistance = ([lat1, lon1], [lat2, lon2]) => {
	const deltaLat = distance(lat2, lat1);
	const deltaLon = distance(lon2, lon1);
	lat1 = toRadian(lat1);
	lat2 = toRadian(lat2);
	const a = Math.pow(Math.sin(deltaLat / 2), 2) + Math.pow(Math.sin(deltaLon / 2), 2) * Math.cos(lat1) * Math.cos(lat2);
	const miles = RADIUS_OF_EARTH_IN_KM * (2 * Math.asin(Math.sqrt(a))) / KM_TO_MILES;
	return Math.round(miles * 10) / 10;
};

//#endregion
export { haversineDistance };